import axios from './../axiosInstance';

export function synchronizeLogosApi() {
    return axios.get(`/logos/synchronize`).then(res => res.data);
}
